import React from "react";
import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin } from "@phosphor-icons/react";
import { NAV, COMPANY } from "@/lib/content";

const legal = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms of Use", to: "/terms-of-use" },
  { label: "Investment Disclaimer", to: "/investment-disclaimer" },
];

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-forest text-white overflow-hidden" data-testid="site-footer">
      <div className="grain" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="inline-flex bg-white rounded-sm p-4 mb-5">
              <img src="/redwood-logo.png" alt="Redwood Capital Holdings, Inc." className="h-20 w-auto" />
            </div>
            <p className="text-white/60 max-w-sm leading-relaxed">
              A real estate investment and development company identifying, acquiring, and developing
              strategically located opportunities across Charlotte and surrounding high-growth markets.
            </p>
            <p className="mt-6 font-serif text-lg text-gold italic">{COMPANY.tagline}</p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-gold mb-5">Explore</h4>
            <ul className="space-y-3">
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-white/70 hover:text-white transition-colors duration-200 text-sm"
                    data-testid={`footer-nav-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/submit-property" className="text-gold hover:text-gold-light transition-colors duration-200 text-sm font-semibold">
                  Submit a Property
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-gold mb-5">Contact</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3 text-white/70">
                <MapPin size={20} className="text-gold shrink-0 mt-0.5" />
                <span>{COMPANY.name}<br />{COMPANY.location}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={20} className="text-gold shrink-0" />
                <a href={COMPANY.phoneHref} className="text-white/70 hover:text-white transition-colors" data-testid="footer-phone">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <EnvelopeSimple size={20} className="text-gold shrink-0" />
                <a href={`mailto:${COMPANY.email}`} className="text-white/70 hover:text-white transition-colors" data-testid="footer-email">
                  {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="hairline my-12 opacity-40" />

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <p className="text-white/40 text-xs">
            &copy; {year} {COMPANY.name} All rights reserved.
          </p>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {legal.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="text-white/40 hover:text-white/80 transition-colors text-xs"
                data-testid={`footer-${l.to.replace("/", "")}`}
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>

        <p className="mt-8 text-white/30 text-[11px] leading-relaxed max-w-4xl">
          The information contained on this website is provided for informational purposes only and does not
          constitute an offer to sell or a solicitation of an offer to purchase any security or investment product.
          Redwood Capital Holdings, Inc. makes no representation regarding the suitability of any opportunity for any person.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
